import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import Header from './components/Header';
import Table from './components/Table';
import List from './components/List';

const LiftStatusReport = ({
  endpoint,
  feedKey,
  areaKey,
  isSummer,
  openLabel,
  closedLabel,
  holdLabel,
  liftLabel,
  typeLabel,
  hoursLabel,
  areaLabel,
  elevationGainLabel,
  timeLabel,
  unavailableMessage
}) => {
  const [report, setReport] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const { data } = await Axios({
          method: 'GET',
          url: endpoint,
          params: {
            mountain: feedKey,
            areas: areaKey,
            isSummer
          }
        });

        setReport(data);
      } catch (e) {
        console.log('Error fetching Lift Status Report data.');
      }
      setLoaded(true);
    };

    fetchFeed();
  }, [areaKey, endpoint, feedKey]);

  const getIcon = status => {
    switch (status.toLowerCase()) {
      case 'open':
        return '#open';
      case 'closed':
        return '#closed';
      case 'hold':
      case 'on hold':
        return '#alert';
    }
  };

  return (
    <>
      {loaded && report.liftStatuses && (
        <>
          <Header
            openLabel={openLabel}
            closedLabel={closedLabel}
            holdLabel={holdLabel}
            lastUpdated={report.lastUpdated}
            getIcon={getIcon}
          />
          <Table
            liftLabel={liftLabel}
            typeLabel={typeLabel}
            hoursLabel={hoursLabel}
            areaLabel={areaLabel}
            elevationGainLabel={elevationGainLabel}
            timeLabel={timeLabel}
            liftStatuses={report.liftStatuses}
            getIcon={getIcon}
          />
          <List
            typeLabel={typeLabel}
            hoursLabel={hoursLabel}
            areaLabel={areaLabel}
            elevationGainLabel={elevationGainLabel}
            timeLabel={timeLabel}
            liftStatuses={report.liftStatuses}
            getIcon={getIcon}
          />
        </>
      )}
      {loaded && !report.liftStatuses && <p>{unavailableMessage}</p>}
    </>
  );
};

LiftStatusReport.propTypes = {
  endpoint: PropTypes.string.isRequired,
  feedKey: PropTypes.string.isRequired,
  areaKey: PropTypes.string,
  isSummer: PropTypes.string,
  openLabel: PropTypes.string.isRequired,
  closedLabel: PropTypes.string.isRequired,
  holdLabel: PropTypes.string.isRequired,
  liftLabel: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  areaLabel: PropTypes.string.isRequired,
  elevationGainLabel: PropTypes.string.isRequired,
  timeLabel: PropTypes.string.isRequired,
  unavailableMessage: PropTypes.string.isRequired
};

export default LiftStatusReport;
